import { NewPromptFields, type useNewPromptForm } from '../NewPromptForm';

type PromptForm = ReturnType<typeof useNewPromptForm>;

type SetupPromptStepProps = {
  form: PromptForm;
  creatingPrompt: boolean;
  onSubmit: () => void;
};

export function SetupPromptStep({ form, creatingPrompt, onSubmit }: SetupPromptStepProps) {
  return (
    <div className="d-flex flex-column gap-3">
      {form.missingHint && <p className="fs--2 text-500 mb-0">{form.missingHint}</p>}
      <NewPromptFields
        form={form}
        formId="setup-prompt-form"
        autoFocus
        showModelSearch={false}
        promptHelp="سوالی که کاربر از AI می‌پرسد را بنویسید. هر خط یک پرامپت است"
        onTextKeyDown={(e) => {
          if ((e.metaKey || e.ctrlKey) && e.key === 'Enter' && form.canSubmit && !creatingPrompt) {
            e.preventDefault();
            void onSubmit();
          }
        }}
        onSubmit={() => void onSubmit()}
      />
    </div>
  );
}
